/**
 * Sold-out notify form (blocks/sold-out-actions.liquid).
 *
 * Sends the "notify me" form without leaving the page and swaps in the thank-you message. If anything looks off
 * (a bot check, a network problem, an unexpected answer) it falls back to a normal form post, so a request is never
 * lost: Shopify then reloads the page with its own success or error message.
 */

class SoNotify extends HTMLElement {
  connectedCallback() {
    this.form = this.querySelector('form');
    this.form?.addEventListener('submit', (event) => this.#onSubmit(event));
  }

  /** @param {SubmitEvent} event */
  async #onSubmit(event) {
    const form = this.form;
    if (!(form instanceof HTMLFormElement) || !form.checkValidity()) return; // The browser shows its own message

    event.preventDefault();

    const button = form.querySelector('[type="submit"]');
    if (button instanceof HTMLButtonElement) button.disabled = true;

    try {
      const response = await fetch(form.action, {
        method: 'POST',
        body: new FormData(form),
        headers: { 'X-Requested-With': 'XMLHttpRequest' },
        redirect: 'follow',
      });

      // A bot check or anything but a clean "posted" answer: let the normal form post handle it
      const posted = response.ok && /(contact|customer)_posted=true/.test(response.url);
      if (!posted) {
        this.#fallback(form);
        return;
      }

      const fields = form.querySelector('.so-act__fields');
      const success = form.querySelector('[data-success]');
      if (fields instanceof HTMLElement) fields.hidden = true;
      if (success instanceof HTMLElement) success.hidden = false;
    } catch (_) {
      this.#fallback(form);
    }
  }

  /** @param {HTMLFormElement} form */
  #fallback(form) {
    HTMLFormElement.prototype.submit.call(form);
  }
}

if (!customElements.get('so-notify')) customElements.define('so-notify', SoNotify);
